export default __webpack_public_path__ + "static/media/typeCar.4d6ad9a8.4d6ad9a8.svg";